import { Colors } from "@/constants/colors";
import { cn } from "@/lib/utils";

export const iconName = {
  add: "i-bp-add",
  apple: "i-bp-apple",
  announce: "i-bp-announce",
  "arrow-right": "i-bp-arrow-right",
  "arrow-left": "i-bp-arrow-left",
  "arrow-left-wall": "i-bp-arrow-left-wall",
  "arrow-right-wall": "i-bp-arrow-right-wall",
  back: "i-bp-back",
  bank: "i-bp-bank",
  calendar: "i-bp-calendar",
  "channel-bold": "i-bp-channel-bold",
  channel: "i-bp-channel",
  check: "i-bp-check",
  checked: "i-bp-checked",
  "chevron-down": "i-bp-chevron-down",
  "chevron-right": "i-bp-chevron-right",
  close: "i-bp-close",
  copy: "i-bp-copy",
  decrease: "i-bp-decrease",
  dropdown: "i-bp-dropdown",
  "dollar-circle": "i-bp-dollar-circle",
  "ellipsis-vertical": "i-bp-ellipsis-vertical",
  ellipsis: "i-bp-ellipsis",
  email: "i-bp-email",
  external: "i-bp-external",
  "eye-closed": "i-bp-eye-closed",
  eye: "i-bp-eye",
  failed: "i-bp-failed",
  google: "i-bp-google",
  guide: "i-bp-guide",
  "heart-fill": "i-bp-heart-fill",
  heart: "i-bp-heart",
  help: "i-bp-help",
  increase: "i-bp-increase",
  info: "i-bp-info",
  invoice: "i-bp-invoice",
  loading: "i-bp-loading",
  "mood-angry": "i-bp-mood-angry",
  "mood-dark": "i-bp-mood-dark",
  "mood-dreamy": "i-bp-mood-dreamy",
  "mood-euphoric": "i-bp-mood-euphoric",
  "mood-funny": "i-bp-mood-funny",
  "mood-happy": "i-bp-mood-happy",
  "mood-jazzy": "i-bp-mood-jazzy",
  "mood-mysterious": "i-bp-mood-mysterious",
  "mood-peaceful": "i-bp-mood-peaceful",
  "mood-quirky": "i-bp-mood-quirky",
  "mood-relaxed": "i-bp-mood-relaxed",
  "mood-romantic": "i-bp-mood-romantic",
  "mood-sad": "i-bp-mood-sad",
  "mood-scary": "i-bp-mood-scary",
  "mood-sentimental": "i-bp-mood-sentimental",
  "mood-suspense": "i-bp-mood-suspense",
  music: "i-bp-sidebar-music",
  next: "i-bp-next",
  notification: "i-bp-notification",
  password: "i-bp-password",
  "pause-fill": "i-bp-pause-fill",
  pause: "i-bp-pause",
  "pause-bold": "i-bp-pause-bold",
  "payout-accrued": "i-bp-payout-accrued",
  "payout-completed": "i-bp-payout-completed",
  "payout-progress": "i-bp-payout-progress",
  pending: "i-bp-pending",
  "play-fill": "i-bp-play-fill",
  play: "i-bp-play",
  plus: "i-bp-plus",
  qr: "i-bp-qr",
  "qr-code": "i-bp-qr-code",
  "radio-selected": "i-bp-radio-selected",
  radio: "i-bp-radio",
  settings: "i-bp-settings",
  shield: "i-bp-shield",
  "sign-out": "i-bp-sign-out",
  "skip-next": "i-bp-skip-next",
  "skip-prev": "i-bp-skip-prev",
  star: "i-bp-star",
  trash: "i-bp-trash",
  user: "i-bp-user",
  videos: "i-bp-videos",
  share: "i-bp-share",
  search: "i-bp-search",
  "youtube-bold": "i-bp-youtube-bold",
  swap: "i-bp-swap",
  download: "i-bp-download",
} as const;

export const iconBgColors = Colors.bg;
export const iconColors = Colors.text;

interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  name: keyof typeof iconName;
  bgColor?: keyof typeof iconBgColors;
  iconColor?: keyof typeof iconColors;
  iconSize?: string;
}

export function Icon({ name, className, bgColor, iconColor, iconSize, ...props }: IconProps) {
  const iconSizeStyle = iconSize ? { width: iconSize, height: iconSize } : {};
  if (bgColor == null) {
    return (
      <i
        className={cn("inline-block size-4", iconName[name], iconColor && iconColors[iconColor], className)}
        style={iconSizeStyle}
        {...props}
      />
    );
  }

  return (
    <div
      className={cn("inline-flex items-center justify-center rounded-full p-4", iconBgColors[bgColor], className)}
      {...props}
    >
      <i
        className={cn("inline-block size-4", iconName[name], iconColor && iconColors[iconColor])}
        style={iconSizeStyle}
      />
    </div>
  );
}
